import { useCallback, useMemo, useState } from 'react';

export function warmupOpenKey(slug: string): string { return `shoot-warmup:${slug}:open`; }

export function readWarmupOpen(slug: string): boolean {
  try { return window.localStorage.getItem(warmupOpenKey(slug)) !== 'false'; }
  catch { return true; }
}

export function writeWarmupOpen(slug: string, open: boolean): void {
  try { window.localStorage.setItem(warmupOpenKey(slug), String(open)); }
  catch { /* Device storage is optional. */ }
}

export function useWarmupOpen(slug: string): [boolean, (open: boolean) => void] {
  const fallback = useMemo(() => slug ? readWarmupOpen(slug) : true, [slug]);
  const [choice, setChoice] = useState<{ slug: string; open: boolean } | null>(null);
  const setOpen = useCallback((open: boolean) => {
    setChoice({ slug, open });
    if (slug) writeWarmupOpen(slug, open);
  }, [slug]);
  return [choice?.slug === slug ? choice.open : fallback, setOpen];
}
